import { render, staticRenderFns } from "./BusCommonManageAppVersionModal.vue?vue&type=template&id=304b6c02&"
import script from "./BusCommonManageAppVersionModal.vue?vue&type=script&lang=js&"
export * from "./BusCommonManageAppVersionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports